<div class="table-responsive">
  <div class="Survey-Inventory-Div pb-5">
    <div class="fw-bold text-dark Inv-class">
      Inventory
    </div>
    <div class="Survey-Filter-Div">
      <div class="d-inline-block" *ngIf="switchUserAccess">
        <button (click)="initSendMailPopup(true)"
        class="btn btn-primary btn-inventory fs-6 send-mail-btn"
        >
          Send Mail
          <img class="whatsappwhite-img" src="assets/media/icons/message.png" />
        </button>
      </div>
      <div ngbDropdown class="d-inline-block" *ngIf="surveyService.accessRoles.survey && surveyService.accessRoles.survey.share_inventory" #myDrop="ngbDropdown">
        <button 
          id="dropdownBasic1"
          ngbDropdownToggle
          class="btn btn-primary btn-inventory fs-6"
          >
          Share Inventory
          <img class="whatsappwhite-img" src="assets/media/icons/whatsappwhite.png" />
        </button>
        <div class="" ngbDropdownMenu aria-labelledby="dropdownBasic1">
          <div *ngIf="shareInventoryContainer &&  shareInventoryContainer.users && shareInventoryContainer.users.length > 0" class="Share-Popup">
            <div class="share-Heading">
              <div class="fw-bold fs-5 text-dark">
                Share
              </div>
              <div>
                <img
                (click)="copyClipBoard(shareInventoryContainer.overall_text)" 
                class="copy-Icon" 
                [src]="'assets/media/icons/copy.png'"
                />
                <img (click)="$event.stopPropagation(); myDrop.close();" style="width: 12px; cursor: pointer;" src="assets/media/icons/close_black.png" />
              </div>
            </div>
  
            <div class="separator border-gray-200"></div>
            <div  style="margin-top: 10px;">
              <ng-container *ngFor="let item of shareInventoryContainer.users">
                <div *ngIf="item.phone && item.phone != '' && item.phone.length>=10" class="share-info-details">
                  <div class="text-dark fw-bold fs-6">
                    {{item.name}}
                  </div>
                  <div style="display:flex; justify-content:space-between; align-items: center;">
                    <img
                      (click)="copyClipBoard(item.message)" 
                      class="copy-Icon" 
                      [src]="'assets/media/icons/copy.png'"
                    />
                    <a
                      target="_blank" 
                      [href]="CreateUrl(item)">
                      <img
                        class="whatApp-Icon"
                        [src]="'assets/media/icons/whapp.png'"
                      />
                    </a>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>



          <div class="Share-Popup" *ngIf="shareInventoryContainer &&  shareInventoryContainer.users && shareInventoryContainer.users.length == 0">
            <div class="share-Heading1">
              <div class="fw-bold fs-5 text-dark">
                Share
              </div>
              <div>
                <img
                (click)="copyClipBoard(shareInventoryContainer.overall_text)" 
                class="copy-Icon" 
                [src]="'assets/media/icons/copy.png'"
                />
                <img (click)="$event.stopPropagation(); myDrop.close();" style="width: 12px; cursor: pointer;" src="assets/media/icons/close_black.png" />
              </div>
            </div>
            <div class="text-center fw-bold fs-5 text-muted mt-3">
              No Contact to Show 
            </div>
          </div>

        </div>
      </div>




      
      <!-- <button 
        *ngIf="surveyService.accessRoles.survey && surveyService.accessRoles.survey.share_inventory" 
        class="btn btn-primary btn-inventory fs-6"
        (click)="openSharePopup()"
        >
        Share Inventory
        <img class="whatsappwhite-img" src="../../../../assets/media/icons/whatsappwhite.png" />
      </button>

      <div *ngIf="shareInventoryPopUp">
        
        <div class="Share-Popup">
          <div class="share-Heading">
            <div class="fw-bold fs-5 text-dark">
              Share
            </div>
            <div>
              <img (click)="closePopup()" style="width: 12px; cursor: pointer;" src="../../../../assets/media/icons/close_black.png" />
            </div>
          </div>

          <div class="separator border-gray-200"></div>

          <div *ngIf="shareInventoryContainer.users.length > 0" style="margin-top: 10px;">
            <ng-container *ngFor="let item of shareInventoryContainer.users">
              <div *ngIf="item.phone && item.phone != '' && item.phone.length>=10" class="share-info-details">
                <div class="text-dark fw-bold fs-6">
                  {{item.name}}
                </div>
                <div class="display:flex">
                  <img
                    class="copy-Icon" 
                    (click)="copyClipBoard(item.message)" 
                    src="../../../../assets/media/icons/inventory/c-icon.png"
                  />
                  <a
                    target="_blank" 
                    [href]="CreateUrl(item)">
                    <img
                      class="whatApp-Icon"
                      src="../../../../assets/media/icons/inventory/wh-app.png" 
                    />
                  </a>
                </div>
              </div>
            </ng-container>
          </div>

          <div class="text-center fw-bold fs-5 text-muted mt-3"*ngIf="shareInventoryContainer.users.length == 0">
            No Contact to Show 
          </div>


        </div>

      </div> -->

      <div class="filter-dropdown-container" *ngIf="surveyService.accessRoles.survey && surveyService.accessRoles.survey.filter && surveyService.accessRoles.survey.filter.view">
        <div class="card-toolbar">
          <button
            type="button"
            class="btn btn-sm fw-bold btn-white shadow apply-filter-btn"
            data-kt-menu-trigger="click"
            data-kt-menu-placement="bottom-end"
            data-kt-menu-flip="top-end"
            data-kt-menu-static="true"
            #filter
          >
            <img src="../../../assets/media/icons/filter.png" class="filter-icon" alt=""/>
            <span class="text-muted fs-7"> Apply Filter 
            </span>
          </button>
          <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-250px py-3"
           data-kt-menu="true">
            <div class="pt-0 pb-3 px-4 filter-heading">
              <div class="fs-5 text-dark fw-bold">Filter Options</div>
              <div> <img data-kt-menu-dismiss="true" style="width: 12px; height: 12px; cursor: pointer;" src="../../../assets/media/icons/close_black.png" /></div>
            </div>
            
            <div class="separator border-gray-200"></div>

            <div class="mt-3" *ngIf="surveyService.accessRoles.survey.filter.status">
              <div class="text-dark fw-bold fs-6 ms-5">Status</div>
              <div class="Status-div">
                <select class="form-select text-muted fw-bold" name="surveyStatusFilter" [(ngModel)]="surveyStatusFilter">
                  <option value="">Select Option</option>
                  <option value="active">Active</option>
                  <option value="inactive">In Active</option>
                  <option value="expired">Expired</option>
                  <option value="upcoming">Upcoming</option>
                  <!-- <option value="inactive">Active</option> -->
                </select>
              </div>
            </div>
            
            <div class="px-7 pt-5 pb-2">
              <div class="d-flex justify-content-end">
                <button
                  type="reset"
                  class="btn btn-sm btn-light btn-active-light-primary me-2"
                  data-kt-menu-dismiss="true"
                  (click)="resetFilter()"
                >
                  Reset
                </button>
            
                <button
                  type="button"
                  class="btn btn-sm btn-primary"
                  data-kt-menu-dismiss="true"
                  (click)="applyFilter()"
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>


  <div class="pb-5 main-container" *ngIf="isSurvayListCallDone">
    <div class="" *ngIf="surveys && surveys.length">
      <table class="top_performers table table-row-dashed table-row-gray-300 gy-7">
        <thead>
          <tr class="fw-bold fs-6 text-gray-800 bg-white">
          <th class="table-th" >Sl No.</th>
          <!-- <th class="table-th" scope="col" [appSort]="surveys" data-order="desc" data-name="name">Survey Name
            <span>
              <img class="filter-arrow" *ngIf="!(utility.sortColumn.column == 'name' && utility.sortColumn.direction =='asc')" src="../../../../assets/media/icons/arrowdown.png" alt="">
              <img class="filter-arrow" *ngIf="utility.sortColumn.column == 'name' && utility.sortColumn.direction =='asc'" src="../../../../assets/media/icons/arrowup.png" alt="">
            </span>
          </th> -->
          <th class="table-th">Survey Name</th>
          <th class="table-th" scope="col" [appSort]="surveys" data-order="desc" data-name="full_start" data-type="date">Start Date
            <span>
              <img class="filter-arrow" *ngIf="!(utility.sortColumn.column == 'full_start' && utility.sortColumn.direction =='asc')" src="../../../../assets/media/icons/arrowdown.png" alt="">
              <img class="filter-arrow" *ngIf="utility.sortColumn.column == 'full_start' && utility.sortColumn.direction =='asc'" src="../../../../assets/media/icons/arrowup.png" alt="">
            </span>
          </th>
          <th class="table-th" scope="col" [appSort]="surveys" data-order="desc" data-name="full_complete" data-type="date">End Date
            <span>
              <img class="filter-arrow" *ngIf="!(utility.sortColumn.column == 'full_complete' && utility.sortColumn.direction =='asc')" src="../../../../assets/media/icons/arrowdown.png" alt="">
              <img class="filter-arrow" *ngIf="utility.sortColumn.column == 'full_complete' && utility.sortColumn.direction =='asc'" src="../../../../assets/media/icons/arrowup.png" alt="">
            </span>
          </th>
          <th class="table-th">Status</th>
          <th class="table-th" scope="col" [appSort]="surveys" data-order="desc" data-name="cpi">CPI<span class="rupee svg-icon-3 me-1">(&#8377;)</span>
            <span>
              <img class="filter-arrow" *ngIf="!(utility.sortColumn.column == 'cpi' && utility.sortColumn.direction =='asc')" src="../../../../assets/media/icons/arrowdown.png" alt="">
              <img class="filter-arrow" *ngIf="utility.sortColumn.column == 'cpi' && utility.sortColumn.direction =='asc'" src="../../../../assets/media/icons/arrowup.png" alt="">
            </span>
          </th>
          <th class="table-th" scope="col" [appSort]="surveys" data-order="desc" data-name="loi">Expected LOI (min)
            <span>
              <img class="filter-arrow" *ngIf="!(utility.sortColumn.column == 'loi' && utility.sortColumn.direction =='asc')" src="../../../../assets/media/icons/arrowdown.png" alt="">
              <img class="filter-arrow" *ngIf="utility.sortColumn.column == 'loi' && utility.sortColumn.direction =='asc'" src="../../../../assets/media/icons/arrowup.png" alt="">
            </span>
          </th>
          <th class="table-th" scope="col" [appSort]="surveys" data-order="desc" data-name="ir">Expected IR (%)
            <span>
              <img class="filter-arrow" *ngIf="!(utility.sortColumn.column == 'ir' && utility.sortColumn.direction =='asc')" src="../../../../assets/media/icons/arrowdown.png" alt="">
              <img class="filter-arrow" *ngIf="utility.sortColumn.column == 'ir' && utility.sortColumn.direction =='asc'" src="../../../../assets/media/icons/arrowup.png" alt="">
            </span>
          </th>
          <!-- <th class="table-th">Exclusive Sample Size</th>
          <th class="table-th">Shared Sample Size</th> -->

          <th class="table-th">Completes</th>
          <th class="table-th">Remaining Exclusive</th>
          <th class="table-th">Remaining Shared</th>
          <th class="table-th">Survey Action</th>
          </tr>
        </thead>
        <tbody>
          <tr [ngClass]="{'switchUserTable':surveyService.accessRoles.header && surveyService.accessRoles.header.switch_user}" class="bg-white" *ngFor="let survey of surveys; let i=index">
            <td class="table-td">{{i + 1}}</td>
            <td class="table-td" style="padding: 0px 2px !important;">
              <a style="text-decoration: none; cursor: pointer; font-weight: 700" class="text-primary text-center nav-link" (click)="StudyDetails(survey)">{{survey.name || "-"}}</a>
            </td>
            <td class="table-td" style="padding: 0px 5px !important;">{{survey.start || "-"}}</td>
            <td class="table-td">{{survey.complete || "-"}}</td>
            <td class="table-td">{{survey.status || "-"}}</td>
            <td class="table-td">{{survey.cpi || "-"}}</td>
            <td class="table-td">{{survey.loi || "-"}}</td>
            <td class="table-td">{{survey.ir || "-"}}</td>
            <!-- <td class="table-td">
              <span>{{survey.crownit_achieved_sample || "0"}}</span>
              /<span>{{survey.crownit_sample_size || "0"}}</span>
            </td>
            <td class="table-td">
              <span>{{survey.achieved_sample || "0"}}</span>
              /<span>{{survey.sample_size || "0"}}</span>
            </td> -->

            <td class="table-td">
              <span>{{survey.completes || "0"}}</span>
            </td>
            <td class="table-td">
              <span>{{survey.remaining_exclusive || "0"}}</span>
            </td>

            <td class="table-td">
              <span>{{survey.remaining_shared || "0"}}</span>
            </td>


            <td class="table-td">
              <div class="survey-action-container" style="position: relative;">
                <button *ngIf="survey.isSurveyLaunching" class="btn btn-sm btn-custom table-btn study-details-btn launching-loader-btn" type="button" disabled>
                  <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                  Launching...
                </button>
                <div class="card-toolbar">
                  <div ngbDropdown class="d-inline-block">
                    <img
                      class="survey-action-icon"
                      [id]="'dropdownBasic' + i"
                      ngbDropdownToggle
                      src="../../../../assets/media/icons/dots.png"
                      alt="Icon"
                    />
                    <div ngbDropdownMenu [attr.aria-labelledby]="'dropdownBasic' + i">
                      <button ngbDropdownItem
                        *ngIf="surveyService.accessRoles.survey && surveyService.accessRoles.survey.details && surveyService.accessRoles.survey.details.view"
                        class="btn btn-sm btn-custom table-btn study-details-btn" (click)="StudyDetails(survey)">
                        View Details
                      </button>
                      <button ngbDropdownItem
                        *ngIf="!survey.isSurveyLaunching && surveyService.accessRoles.survey && surveyService.accessRoles.survey.details && surveyService.accessRoles.survey.details.view"
                        class="btn btn-sm btn-custom table-btn study-details-btn" (click)="launchSurvey(survey)">
                        Launch
                      </button>
                      <button ngbDropdownItem
                        *ngIf="survey.isSurveyLaunching"
                        class="btn btn-sm btn-custom table-btn study-details-btn launching-loader-btn" type="button"
                        disabled>
                        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                        Launching...
                      </button>
                      <button ngbDropdownItem
                        *ngIf="surveyService.accessRoles.survey && surveyService.accessRoles.survey.details && surveyService.accessRoles.survey.details.view"
                        class="btn btn-sm btn-custom table-btn study-details-btn" (click)="openSendCommPopup(survey)">
                        Send Comms
                      </button>
                      <button ngbDropdownItem
                        *ngIf="survey.link && survey.link != '' && surveyService.accessRoles.survey && surveyService.accessRoles.survey.get_link"
                        class="btn btn-sm btn-custom table-btn study-details-btn" (click)="copyOnClick(survey.link)">
                        Get Link
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <div class="null-table-container card shado-effect" *ngIf="!(surveys && surveys.length)">
        <img class="blank-survay-list" src="../../../assets/media/survey/blank_survay_list1.png" alt="" />
        <div class="null-table-text">No Surveys Available</div>
    </div>
  </div>

</div>